export const WuJieBus = Symbol('WuJieBus');

export interface WuJieBus {
    $on(event: string | string[], callback: Function): void;
    $off(event: string | string[], callback: Function): void;
    $emit(event: string, ...args: any[]): void;
}
